import React from 'react';

const TERMS_CSS = `
  .legal-page a { color: #38bdf8; text-decoration: none; }
  .legal-page a:hover { text-decoration: underline; }
  .legal-section { animation: fadeUp 0.4s ease both; }
  @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
`;

export default function TermsPage({ onBack }) {
  return (
    <>
      <style>{TERMS_CSS}</style>
      <div className="legal-page" style={s.page}>
        <div style={s.orb1} /><div style={s.orb2} />

        {/* Header */}
        <div style={s.header}>
          <button onClick={onBack} style={s.backBtn}>← Back</button>
          <div style={s.logo}>💧 <span style={s.logoText}>DailyDroplet</span></div>
          <div style={{ width: 60 }} />
        </div>

        <div style={s.body}>
          <div style={s.heroBox}>
            <h1 style={s.heroTitle}>Terms of Service</h1>
            <p style={s.heroSub}>Last updated: April 13, 2026</p>
          </div>

          <div style={s.card}>

            <Section title="1. Acceptance of Terms">
              <p>By subscribing to DailyDroplet ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not subscribe or use the Service.</p>
              <p>We reserve the right to update these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
            </Section>

            <Section title="2. Description of Service">
              <p>DailyDroplet is a subscription-based SMS digest service that delivers curated links and content summaries to your mobile phone number at a time you choose. Content is aggregated from third-party sources including but not limited to YouTube, NewsAPI, The Guardian, Hacker News, NASA, Alpha Vantage, Currents, GNews, and USDA FoodData Central.</p>
              <p>We do not guarantee the accuracy, completeness, timeliness, or reliability of any content delivered. Content is provided for informational purposes only.</p>
            </Section>

            <Section title="3. SMS Messaging & Consent">
              <p>By providing your phone number and completing signup, you expressly consent to receive recurring automated SMS text messages from DailyDroplet at the number you provided, including:</p>
              <ul>
                <li>A one-time verification code at signup</li>
                <li>A daily digest message at your chosen delivery time</li>
                <li>Occasional service-related notifications</li>
              </ul>
              <p>Message frequency: typically 1 message per day plus verification messages. Message and data rates may apply depending on your carrier plan.</p>
              <p><strong>To stop receiving messages, reply STOP at any time.</strong> You may also unsubscribe through the Manage page. After opting out, you will receive a single confirmation message.</p>
              <p>For help, reply HELP or contact us at support@dailydroplet.com.</p>
              <p>Carriers are not liable for delayed or undelivered messages.</p>
            </Section>

            <Section title="4. Eligibility">
              <p>You must be at least 13 years of age to use the Service. By subscribing, you represent that you are at least 13 years old. If you are under 18, you represent that your parent or legal guardian has reviewed and agreed to these Terms on your behalf.</p>
              <p>The Service is currently available to users with mobile phone numbers in the United States and internationally where SMS delivery is supported.</p>
            </Section>

            <Section title="5. Account & Phone Verification">
              <p>Access to your subscription settings requires verification via a one-time code sent to your registered phone number. You are responsible for maintaining the security of your phone. You agree to notify us immediately if you believe your account has been accessed without your authorization.</p>
            </Section>

            <Section title="6. Acceptable Use">
              <p>You agree not to:</p>
              <ul>
                <li>Provide false information during signup</li>
                <li>Use the Service for any unlawful purpose</li>
                <li>Attempt to reverse-engineer or interfere with the Service</li>
                <li>Share, sell, or transfer your subscription to another party</li>
              </ul>
            </Section>

            <Section title="7. Content & Intellectual Property">
              <p>All content delivered via DailyDroplet is sourced from third-party APIs and services. DailyDroplet does not claim ownership of third-party content. Links in your digest direct you to the original publisher's website.</p>
              <p>The DailyDroplet name, logo, and software are the property of DailyDroplet and may not be used without written permission.</p>
            </Section>

            <Section title="8. Disclaimers & Limitation of Liability">
              <p>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. DAILYDROPLET DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR THAT CONTENT WILL BE ACCURATE OR COMPLETE.</p>
              <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, DAILYDROPLET SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE.</p>
            </Section>

            <Section title="9. Termination">
              <p>We reserve the right to suspend or terminate your subscription at any time for violation of these Terms, carrier requirements, or at our discretion with reasonable notice. You may terminate your subscription at any time by replying STOP or using the Manage page.</p>
            </Section>

            <Section title="10. Governing Law">
              <p>These Terms are governed by the laws of the United States. Any disputes shall be resolved through binding arbitration under the rules of the American Arbitration Association, except where prohibited by law.</p>
            </Section>

            <Section title="11. Contact">
              <p>For questions about these Terms, contact us at: <a href="mailto:legal@dailydroplet.com">legal@dailydroplet.com</a></p>
            </Section>

          </div>
        </div>
      </div>
    </>
  );
}

function Section({ title, children }) {
  return (
    <div className="legal-section" style={s.section}>
      <h2 style={s.sectionTitle}>{title}</h2>
      <div style={s.sectionBody}>{children}</div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', background: '#060d1f',
    fontFamily: "'Inter', system-ui, sans-serif", color: '#94a3b8',
    position: 'relative',
  },
  orb1: { position: 'fixed', top: '5%', left: '5%', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle,rgba(14,165,233,0.07) 0%,transparent 70%)', filter: 'blur(30px)', pointerEvents: 'none', zIndex: 0 },
  orb2: { position: 'fixed', bottom: '10%', right: '5%', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle,rgba(99,102,241,0.06) 0%,transparent 70%)', filter: 'blur(30px)', pointerEvents: 'none', zIndex: 0 },
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '16px 32px', borderBottom: '1px solid #0d1829',
    background: 'rgba(6,13,31,0.9)', backdropFilter: 'blur(16px)',
    position: 'sticky', top: 0, zIndex: 100,
  },
  backBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 500 },
  logo: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 20, fontWeight: 800, color: '#f8fafc' },
  logoText: { background: 'linear-gradient(90deg, #38bdf8, #818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  body: { maxWidth: 760, margin: '0 auto', padding: 'clamp(32px,5vw,56px) clamp(16px,4vw,32px) 80px', position: 'relative', zIndex: 1 },
  heroBox: { marginBottom: 40, textAlign: 'center' },
  heroTitle: { fontSize: 'clamp(2rem,5vw,3rem)', fontWeight: 800, color: '#f8fafc', marginBottom: 8 },
  heroSub: { fontSize: 14, color: '#334155' },
  card: { background: 'rgba(255,255,255,0.02)', border: '1px solid #1e293b', borderRadius: 20, padding: 'clamp(24px,4vw,40px)', display: 'flex', flexDirection: 'column', gap: 0 },
  section: { paddingBottom: 32, marginBottom: 32, borderBottom: '1px solid #0d1829' },
  sectionTitle: { fontSize: 16, fontWeight: 700, color: '#f1f5f9', marginBottom: 14 },
  sectionBody: { display: 'flex', flexDirection: 'column', gap: 10, fontSize: 14, lineHeight: 1.8, color: '#64748b' },
};
